export const FETCH_PATIENTS = "FETCH_PATIENTS";
export const FETCH_MORE_PATIENTS = "FETCH_MORE_PATIENTS";
export const FETCH_CHAT_PATIENT = "FETCH_CHAT_PATIENT";
export const CHECK_USER = "CHECK_USER";
export const SIGNUP_USER = "SIGNUP_USER";
export const ADD_PATIENT = "ADD_PATIENT";

//login user
export const LOGIN_USER = "LOGIN_USER";
//check user permission
export const CHECK_USER_PERMISSION = "CHECK_USER_PERMISSION";
//jwt token
export const JWT_TOKEN_SAGA = "JWT_TOKEN_SAGA";
//chat saga type
export const CHAT_SAGA = "CHAT_SAGA";

export const EMPTY_PATIENT = "EMPTY_PATIENT";

export const UPLOAD_BROADCAST_FILE = "UPLOAD_BROADCAST_FILE";

export const UPLOAD_BROADCAST_COMMA_SEPARATED_VALUES =
  "UPLOAD_BROADCAST_COMMA_SEPARATED_VALUES";

// New broadcast action
export const UPLOAD_BROADCAST_FILE_NEW = "UPLOAD_BROADCAST_FILE_NEW";

// New broadcast Message action
export const BROADCAST_MESSAGE = "BROADCAST_MESSAGE";

export const BROADCAST_MESSAGE_REVIEW = "BROADCAST_MESSAGE_REVIEW";

export const EMPTY_BROADCAST = "EMPTY_BROADCAST";

//active patients type
export const FETCH_ACTIVE_PATIENTS = "FETCH_ACTIVE_PATIENTS";
//unclaimed patients type
export const FETCH_UNCLAIMED_PATIENTS = "FETCH_UNCLAIMED_PATIENTS";
// queued patient type
export const FETCH_QUEUED_PATIENTS = "FETCH_QUEUED_PATIENTS";
//other patients type
export const FETCH_OTHER_PATIENTS = "FETCH_OTHER_PATIENTS";
//Broadcast patient data
export const BROADCAST_PATIENT = "BROADCAST_PATIENT";
//Empty patient message reducer
export const EMPTY_MESSAGE_PATIENT = "EMPTY_MESSAGE_PATIENT";

//load chat module
export const LOAD_OLD_CHAT = "LOAD_OLD_CHAT";
//convert unclaimed patient to claimed patient
export const CONVERT_UNCLAIMED_PATIENT_TO_CLAIMED_PATIENT =
  "CONVERT_UNCLAIMED_PATIENT_TO_CLAIMED_PATIENT";
//convert claimed patient to unclaimed patient
export const CONVERT_CLAIMED_TO_UNCLAIMED_PATIENT =
  "CONVERT_CLAIMED_TO_UNCLAIMED_PATIENT";
// send upload link to patient
export const SEND_UPLOAD_LINK_TO_PATIENT = "SEND_UPLOAD_LINK_TO_PATIENT";
// send document signing link to patient
export const SEND_DOC_SIGN_LINK_TO_PATIENT = "SEND_DOC_SIGN_LINK_TO_PATIENT";
// upload patient files by patient
export const UPLOAD_PATIENT_FILES = "UPLOAD_PATIENT_FILES";
// download patient files by patient
export const DOWNLOAD_PATIENT_FILES = "DOWNLOAD_PATIENT_FILES";
// download signed document by patient
export const DOWNLOAD_SIGNED_DOC = "DOWNLOAD_SIGNED_DOC";
//shift patient to top
export const SHIFT_PATIENT_TO_TOP_SAGA_TYPE = "SHIFT_PATIENT_TO_TOP_SAGA_TYPE";
//reorder unclaimed patients
export const REORDER_UNCLAIMED_PATIENTS_SAGA_TYPE =
  "REORDER_UNCLAIMED_PATIENTS_SAGA_TYPE";
// Reorder queued patients
export const REORDER_QUEUED_PATIENTS_SAGA_TYPE =
  "REORDER_QUEUED_PATIENTS_SAGA_TYPE";
//update message status in backend
export const UPDATE_MESSAGE_STATUS_SAGA_TYPE =
  "UPDATE_MESSAGE_STATUS_SAGA_TYPE";
//update list type of other patients
export const UPDATE_OTHER_PATIENT_LIST_TYPE = "UPDATE_OTHER_PATIENT_LIST_TYPE";
//get patient count of all tabs
export const GET_PATIENT_COUNT = "GET_PATIENT_COUNT";
//save patient count of all tabs
export const SAVE_PATIENT_COUNT = "SAVE_PATIENT_COUNT";
//get broadcast patient list
export const BROADCAST_PATIENT_LIST = "BROADCAST_PATIENT_LIST";
//get broadcast employee list
export const BROADCAST_EMPLOYEE_LIST = "BROADCAST_EMPLOYEE_LIST";
//delete broadcast employee list
export const DELETE_BROADCAST_EMPLOYEE_LIST = "DELETE_BROADCAST_EMPLOYEE_LIST";
//delete broadcast patient list
export const DELETE_BROADCAST_PATIENT_LIST = "DELETE_BROADCAST_PATIENT_LIST";
//delete broadcast apiPatient list
export const DELETE_BROADCAST_APIPATIENT_LIST =
  "DELETE_BROADCAST_APIPATIENT_LIST";
//get broadcast apiPatient list
export const BROADCAST_APIPATIENT_LIST = "BROADCAST_APIPATIENT_LIST";
//get broadcast provider list
export const BROADCAST_PROVIDERS_LIST = "BROADCAST_PROVIDERS_LIST";
//for cancel broadcast messages
export const CANCEL_MESSAGE = "CANCEL_MESSAGE";

//liveAgent chats type
export const FETCH_LIVE_AGENT_CHAT = "FETCH_LIVE_AGENT_CHAT";
//get chat count of all tabs for liveAgent
export const GET_CHAT_COUNT = "GET_CHAT_COUNT";
//save chat count of all tabs for liveAgent
export const SAVE_CHAT_COUNT = "SAVE_CHAT_COUNT";

//convert active chat to closed chat
export const CONVERT_ACTIVE_TO_CLOSED_CHAT = "CONVERT_ACTIVE_TO_CLOSED_CHAT";
//convert closed chat to active chat
export const CONVERT_CLOSED_CHAT_TO_ACTIVE_CHAT =
  "CONVERT_CLOSED_CHAT_TO_ACTIVE_CHAT";

export const SHIFT_CHAT_TO_TOP_SAGA_TYPE = "SHIFT_CHAT_TO_TOP_SAGA_TYPE";

//fetch saved files for broadcast
export const FETCH_SAVED_BROADCAST_FILES = "FETCH_SAVED_BROADCAST_FILES";

//get broadcast preview list
export const BROADCAST_PREVIEW_LIST = "BROADCAST_PREVIEW_LIST";

//get notifications count
export const GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT";
//get notifications count
export const SAVE_NOTIFICATION_COUNT = "SAVE_NOTIFICATION_COUNT";
